export default __webpack_public_path__ + "static/media/assembleFurniture.5ffb3c4e.svg";